// extracted by mini-css-extract-plugin
export default {"container":"L0wV3v","message":"a_2Xxn"};